<template>
	<div class="modal-card">
		<header class="modal-card-head">
		<p class="modal-card-title" v-if="isEditActive">Edit WorkItem</p>
		<p class="modal-card-title" v-else>Add WorkItem</p>
		</header>
	<section class="modal-card-body">
		<form @submit.prevent="editWorkItem">

				<b-field label="Supporter"
					:type="{'is-danger': errors.has('supportAgent')}"
					:message="errors.first('supportAgent')">
					<b-select v-model="workItem.Worker" icon="account" name="supportAgent" v-validate="'required'" data-vv-as="supporter">
						<option v-for="option in supportAgents"
								:value="option.Username"
								:key="option.WorkerId">
							{{ option.Username }}
						</option>
					</b-select>
				</b-field>

				<b-field grouped>
					<b-field label="Date" expanded>
						<b-field :type="{'is-danger': errors.has('FixDate')}"
							:message="errors.first('FixDate')">
							<b-datepicker name="FixDate" v-model="FixDate" placeholder="select a date..." icon="calendar-today"
								:date-formatter="(date) => date.toLocaleDateString('de-CH')"
								:first-day-of-week="1"
								v-validate="'required'"
								data-vv-as="date">
							</b-datepicker>
						</b-field>
					</b-field>
					<b-field label="Hours" expanded
						:type="{'is-danger': errors.has('Hours')}"
						:message="errors.first('Hours')">
						<b-input name="Hours" v-model="Hours" data-vv-as="hours" v-validate="'min_value:0'">
						</b-input>
					</b-field>
					<b-field label="Minutes" expanded
						:type="{'is-danger': errors.has('Minutes')}"
						:message="errors.first('Minutes')">
						<b-numberinput name="Minutes" v-model="Minutes" step="15" :min="workItem.Minutes < 60 ? 15 : undefined" controls-position="compact" controls-rounded v-validate="'min_value:0'" data-vv-as="minutes">
						</b-numberinput>
						
					</b-field>
				</b-field>

				<b-field :addons="false"
					:type="{'is-danger': errors.has('dayTimeCategory')}"
					:message="errors.first('dayTimeCategory')">
					<!--<div class="block">-->
					<b-radio v-model="dayTimeCategory" name="dayTimeCategory" v-validate="'required'" v-for="option in dayTimeCategories" :native-value="option.value" :key="option.value">
						{{ option.name }}
					</b-radio>
					<!--<b-radio v-model="dayTimeCategory" name="dayTimeCategory" native-value="2" v-validate="'required'">
				a-day
			</b-radio>
			<b-radio v-model="dayTimeCategory" name="dayTimeCategory" native-value="3" v-validate="'required'">
				night
			</b-radio>-->
					<!--</div>-->
				</b-field>
				<b-field label="Comment"
					:type="{'is-danger': errors.has('WorkDescription')}"
					:message="errors.first('WorkDescription')">
					<b-input type="textarea" name="WorkDescription" v-model="workItem.WorkDescription" placeholder="Comment" data-vv-as="comment">
					</b-input>
				</b-field>
			</form>
</section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Close
      </button>
      <button type="submit" class="button is-primary" @click="submitWorkItem">Save</button>
    </footer>
  </div>
</template>

<script>
	/* eslint-disable no-console */
export default {
	name: "IntraWorkEditModal",
	props: {
		workItem: {
			type: Object,
			required: false
		},
		isEditActive: {
			type: Boolean,
			required: true
		},
		noTicketExists: {
			type: Boolean,
			required: false
		},
		supportAgents: {
			type: Array,
			required: true
		},
		dayTimeCategories: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			//supportAgent: "",
			FixDate: new Date(this.workItem.FixDate),
			//Minutes: 15,
			dayTimeCategory: this.workItem.DayTimeCategoryId,
			//WorkDescription: "",
			//workItem: {
			//	FixDate: new Date(this.workItem.FixDate)
			//}
		};
	},
	computed: {
		//HoursWithMinutes: {
		//	get: function() {
		//		let obj = {}; 
		//		obj.Hours = Math.floor(this.workItem.Minutes / 60);
		//		obj.Minutes = this.workItem.Minutes % 60;
		//		return obj;
		//	},
		//	set: function (newObj) {
		//		this.workItem.Minutes = (newObj.Hours * 60) + newObj.Minutes;
		//	}
		//},
		Hours: {
			get: function() {
				return Math.floor(this.workItem.Minutes / 60);
			},
			set: function (newH) {
				this.workItem.Minutes = (newH * 60) + this.Minutes;
			}
		},
		Minutes: {
			get: function() {
				return this.workItem.Minutes % 60;
			},
			set: function (newH) {
				this.workItem.Minutes = (this.Hours * 60) + newH;
			}
		}

	},
	methods: {
		submitWorkItem() {
			this.$validator.validateAll().then((result) => {
				if (result) {
                    let payload = {
						SsnSupporter: this.workItem.Worker,
						TicketDate: this.FixDate.getFullYear() + "-" + (this.FixDate.getMonth() + 1) + "-" + this.FixDate.getDate(),
						BillingMinutes: this.workItem.Minutes,
						//BillingMinutes: (this.Hours * 60) + Minutes,
						DayTimeCat: this.dayTimeCategory,
						BillingComment: this.workItem.WorkDescription,
						IntraTicketId: this.workItem.TicketId,
						IntraSliceId: this.workItem.SliceId
					};
					//console.log("submitWork:");
					//console.log(payload);
					//console.log("noTicketExists:");
					//console.log(this.noTicketExists);
					if (this.isEditActive) {
						this.$emit("edit-work-item", payload);
					}
					else if (this.noTicketExists) {
						this.$emit("create-intra-ticket", payload);
					}
					else {
						this.$emit("add-work-item", payload);
					}
                    return;
				}
				this.$buefy.toast.open({
					message: 'Form is not valid! Please check the fields.',
					type: 'is-danger',
					position: 'is-bottom'
				})
			});
			
		}
	}
};
</script>

<style scoped></style>
